module.exports = __webpack_public_path__ + "static/media/add.47dd7ef7.svg";